function showToast( type, time ) {
	let toastToShow = false;

	if ( type === 'success' ) {
		toastToShow = document.getElementById( 'copied-succesfully' );
	} else {
		toastToShow = document.getElementById( 'copy-failed' );
	}

	if ( toastToShow ) {
		toastToShow.classList.add( 'show' );

		setTimeout( () => {
			toastToShow.classList.remove( 'show' );
		}, time );
	}
}

function bindCopyToClipboard() {
	const triggers = document.getElementsByClassName( 'copy-to-clipboard' );

	if ( triggers && [...triggers].length ) {
		[...triggers].forEach( ( element ) => {
			if ( element.hasAttribute( 'data-to-copy' ) ) {
				element.addEventListener( 'click', ( event ) => {
					event.preventDefault();

					navigator.clipboard.writeText( element.getAttribute( 'data-to-copy' ) ).then( ( data ) => {
						showToast( 'success', 2500 );
					}, ( error ) => {
						showToast( 'error', 2500 );
					} );
				} );
			}
		} );
	}
}

export default {
	init() {
		bindCopyToClipboard();
	},
};